// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"251c26b2","151":"886da8de","410":"39dfb35b","890":"f0ab1fbf","909":"dd2df7f4","923":"48854b2d","989":"4303e90c"}[chunkId] + ".chunk.js";
};